// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3060":"d351bd7302ac35b5ed7c","5286":"d351bd7302ac35b5ed7c"}[chunkId] + ".chunk.css";
};